const React = require('react');
const AppProviders = require('./src/providers/AppProviders').default;
const { GatsbyAnalyticsClient } = require('../common/src/analytics');
const { ScrollDepthTracker } = require('../common/src/analytics/scrollDepth');
const { TimeOnPageTracker } = require('../common/src/analytics/timeOnPage');
const { ExitIntentTracker } = require('../common/src/analytics/exitIntent');

let analytics;
let scrollDepth;
let timeOnPage;
let exitIntent;

exports.wrapRootElement = ({ element }) =>
  React.createElement(AppProviders, null, element);

exports.onClientEntry = () => {
  // Initialize analytics on first client load
  if (typeof window !== 'undefined') {
    analytics = new GatsbyAnalyticsClient({
      source: 'marketing-site',
      debug: process.env.NODE_ENV === 'development',
    });

    // Initialize engagement trackers
    scrollDepth = new ScrollDepthTracker(analytics);
    timeOnPage = new TimeOnPageTracker(analytics);
    exitIntent = new ExitIntentTracker(analytics);

    // Start initial page tracking
    scrollDepth.start();
    timeOnPage.start();
    exitIntent.start();

    // Expose globally for manual tracking in components
    window.__MTP_ANALYTICS__ = analytics;

    if (process.env.NODE_ENV === 'development') {
      console.log('[Analytics] Initialized:', analytics);
      console.log('[Analytics] Trackers:', {
        scrollDepth,
        timeOnPage,
        exitIntent,
      });
    }
  }
};

// Notify when route changes to update country context
exports.onRouteUpdate = ({ location, prevLocation }) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('gatsby-route-change'));

    // Track page view on every route change
    if (analytics && location.pathname !== prevLocation?.pathname) {
      // Reset trackers for new page
      if (scrollDepth) scrollDepth.reset();
      if (timeOnPage) timeOnPage.reset();
      if (exitIntent) exitIntent.reset();

      // Track page view
      analytics.trackPageView(location.pathname, {
        title: document.title,
        referrer: document.referrer,
      });

      if (process.env.NODE_ENV === 'development') {
        console.log('[Analytics] Page view:', location.pathname);
        console.log('[Analytics] Trackers reset for new page');
      }
    }
  }
};
